// NPM
import React, { Component } from 'react';

// Components
import AuthNavWrapper from './AuthNavWrapper';
import HeaderNavigation from './HeaderNavigation';
import ResultsNavigation from 'Components/Pages/Results/ResultsNavigation';
import Footer from 'Components/Layout/Footer';

// External Components
import { Navbar } from 'frontend-component-library';

class MobileNavbar extends Component {
  render() {
    return (
      <Navbar className="mobile-only">
        <Navbar.SideDrawer>
          <AuthNavWrapper />
          <HeaderNavigation />
          <ResultsNavigation className="mobile-only" />
          <Footer />
        </Navbar.SideDrawer>
      </Navbar>
    );
  }
}

export default MobileNavbar;



// WEBPACK FOOTER //
// ./src/Components/Layout/MobileNavbar.js